<agpr-take-over-panel
    [id]="id"
    class="agpr-removeFromListsDialog"
    header="Discover.distributionReport.recipient.removeFromListsDialog.header"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange()"
>
    <div class="agpr-removeFromListsDialog-lhp">
        <p>{{ 'Discover.distributionReport.recipient.removeFromListsDialog.message' | localize }}</p>
        <div class="agpr-removeFromListsDialog-filter">
            <agpr-filter-dropdown
                [id]="id + '_filterDropdown'"
                class="agpr-removeFromListsDialog-filterDropdown"
                [showQuickFilter]="true"
                [quickFilterPlaceholder]="'Discover.distributionReport.recipient.removeFromListsDialog.filter.placeholder'"
                [minLength]="3"
                [ariaLabel]="'Discover.distributionReport.recipient.removeFromListsDialog.filter.placeholder'"
                [ariaDescribedBy]="'removeRecipientFromListsDialog_filterChips'"
            ></agpr-filter-dropdown>
            <agpr-filter-chips
                [id]="id + '_filterChips'"
                class="agpr-removeFromListsDialog-filterChips"
            ></agpr-filter-chips>
        </div>
        <div class="agpr-removeFromListsDialog-controlBar">
            <agpr-checkbox
                id="id_checkAll"
                class="agpr-removeFromListsDialog-controlBar-checkbox"
                [binary]="true"
                hiddenLabel="checkAll"
                [disabled]="!totalCount"
                [ngModel]="totalCount > 0 && selectedRecipients?.size >= recipients?.length"
                (ngModelChange)="toggleCheckAll($event)"
            >
                <span
                    class="agpr-removeFromListsDialog-checkbox-label"
                    [innerHTML]="
                        'Discover.distributionReport.recipient.removeFromListsDialog.count'
                        | localize: {
                            selectedCount: selectedRecipients?.size || '0',
                            totalCount: totalCount || '0'
                        }
                    "
                ></span>
            </agpr-checkbox>
            <agpr-paginator
                [id]="id + '_paginator'"
                class="agpr-removeFromListsDialog-controlBar-paginator"
                [isDisabled]="!totalCount"
            ></agpr-paginator>
        </div>
        @if(selectedRecipients.size >= recipients.length && totalCount > 0) {
            @if(isAllRecipientsSelected || selectedRecipients.size >= totalCount){
                <agpr-message
                    class="agpr-removeFromListsDialog-infoMessage"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Discover.distributionReport.recipient.removeFromListsDialog.infoMessage2' | localize: {count: totalCount} }}
                    <agpr-button
                        [style]="buttonTypesEnum.link"
                        [label]="'Discover.distributionReport.recipient.removeFromListsDialog.infoLink2' | localize"
                        [underline]="true"
                        [uppercase]="false"
                        (click)="toggleSelectAll(false)"
                    ></agpr-button>
                </agpr-message>
            } @else {
                <agpr-message
                    class="agpr-removeFromListsDialog-infoMessage"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Discover.distributionReport.recipient.removeFromListsDialog.infoMessage1' | localize: {count: recipients.length} }}
                    <agpr-button
                        [style]="buttonTypesEnum.link"
                        [label]="'Discover.distributionReport.recipient.removeFromListsDialog.infoLink1' | localize: {count: totalCount}"
                        [underline]="true"
                        [uppercase]="false"
                        (click)="toggleSelectAll(true)"
                    ></agpr-button>
                </agpr-message>
            }
        }
        <agpr-table
            [id]="id + '_table'"
            class="agpr-removeFromListsDialog-table"
            [columns]="columnDefs"
            [(ngModel)]="recipients"
            [highlightedRow]="highlightedRow"
            (highlightedRowChanged)="handleHighlightedRowChanged($event)"
            (itemChanged)="handleTableItemChanged($event)"
            [enableSelectAll]="false"
        >
            <ng-template let-row="row" let-column="column" let-rowIndex="rowIndex" #recipientsCell>
                <div class="agpr-removeFromListsDialog-recipientsCell">
                    <img
                        class="agpr-removeFromListsDialog-recipientsCell-thumbnail"
                        [agprImageSrc]="row.avatarUrl"
                        [agprDefaultImage]="entityTypeDefaultImageEnum.SMALL_CONTACT"
                        alt="thumbnail"
                    />
                    <div class="agpr-removeFromListsDialog-recipientsCell-content">
                        <div class="agpr-removeFromListsDialog-recipientsCell-name">
                            @if(row.entityType === entityType.CONTACT) {
                                <span [agprTooltip]="row.contactName">
                                    {{row.contactName}}
                                </span>
                            }
                            @if(row.entityType === entityType.OUTLET) {
                                <span [agprTooltip]="row.name">
                                    {{row.name}}
                                </span>
                            }
                        </div>
                        <agpr-button
                            class="agpr-removeFromListsDialog-recipientsCell-outlet"
                            [style]="buttonTypesEnum.link"
                            [label]="row.selectedEmployment?.outlet?.name"
                            [tooltip]="row.selectedEmployment?.outlet?.name"
                            [underline]="true"
                            [uppercase]="false"
                            (click)="setOutletId(row.selectedEmployment?.outlet?.id)"
                            [disabled]="!row.selectedEmployment?.outlet?.id"
                        ></agpr-button>
                    </div>
                </div>
            </ng-template>
            <ng-template let-row="row" let-column="column" let-rowIndex="rowIndex" #issueCell>
                <div class="agpr-removeFromListsDialog-issueCell">
                    {{ topStatLabels.get(row.relevantNegativeStat) | localize }}
                </div>
            </ng-template>
            <ng-template let-row="row" let-column="column" let-rowIndex="rowIndex" #listsCell>
                <div class="agpr-removeFromListsDialog-listsCell">
                    <agpr-chip-container
                        class="agpr-removeFromListsDialog-chipContainer"
                        [chips]="row.listMembershipChips"
                        [readonly]="true"
                        [noTooltips]="true"
                        [wrapChips]="false"
                    ></agpr-chip-container>
                </div>
            </ng-template>
        </agpr-table>
    </div>

    <div class="agpr-removeFromListsDialog-rhp">
        <agpr-rhp-contexts
            [id]="id + '_rhpContext'"
            [disableContentToggle]="true"
            [useWhiteBg]="true"
            [showFooter]="false"
        >
        </agpr-rhp-contexts>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            [style]="buttonTypesEnum.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [style]="buttonTypesEnum.primary"
            label="Discover.distributionReport.recipient.removeFromListsDialog.saveButton"
            [disabled]="selectedRecipients.size === 0 && !isAllRecipientsSelected"
            (click)="removeFromLists()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
